import { Box, Button, Typography, Modal } from '@mui/material';
import { useTranslation } from 'react-i18next';

const BodyAskEditModal = ({ open, setOpen, setOpenCreate, setTypeBox, setOpenCreateSession, type }) => {
  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '347.92px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: '20px 30px 20px 30px',
    height: '188px',
    borderRadius: '12.21px',
  };

  const { t } = useTranslation();

  const handleClose = () => setOpen(false);

  const handleEditClick = () => {
    if (type === 'session') {
      setOpenCreateSession(true);
    } else {
      setOpenCreate(true);
    }
    setOpen(false);
    setTypeBox('edit');
  };

  return (
    <div style={{ display: 'flex' }}>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={modalStyle}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              paddingTop: '15px',
            }}>
            <Box sx={{ marginBottom: '15px' }}>
              <Typography>{t('Do you want to edit it?')}</Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '20px',
                width: '200px',
                alignItems: 'center',
              }}>
              <Typography sx={{ textAlign: 'center', color: 'red' }}>
                {t('If modified, the corresponding Your entire session will change')}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                width: '210px',
              }}>
              <Button
                sx={{
                  borderRadius: '4.88px',
                  height: '30px',
                  width: '100px',
                  border: '1px solid #0F7F85 ',
                }}
                onClick={handleClose}>
                {t('CANCEL')}
              </Button>
              <Button
                sx={{
                  borderRadius: '4.88px',
                  height: '30px',
                  width: '100px',
                  border: '1px solid #0F7F85 ',
                }}
                variant="contained"
                onClick={handleEditClick}>
                {t('CONFIRM')}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default BodyAskEditModal;
